import {
  ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY,
  CALCULATE_BALANCE_DUE_FOR_REG_MANAGE,
  CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE,
  CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE,
  CANCEL_PURCHASED_ENTRY_FORM,
  CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE,
  CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE,
  CLEAR_CART_BOWLERS,
  CLEAR_CART_ITEMS,
  CLEAR_POSITION_FOR_REG_ROSTERS,
  CONVERT_ENTRIES_FROM_CART,
  CONVERT_VIRTUAL_ENTRIES_FROM_CART,
  CREATE_CART_ROSTER_POSITIONS,
  DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE,
  DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN,
  DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM,
  DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  DISPLAY_PURCHASED_ENTRIES,
  DISPLAY_PURCHASED_ENTRY_FORM,
  DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES,
  DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM,
  DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES,
  DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE,
  DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE,
  MOVE_POSITION_DOWN_FOR_REG_ROSTERS,
  MOVE_POSITION_UP_FOR_REG_ROSTER,
  REINSERT_MANAGED_ROSTER_IDS_INTO_CART,
  REMOVE_CART_ENTRY,
  REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART,
  RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT,
  SEARCHING_MEMBER_FINISHED,
  SEARCHING_MEMBER_STARTS,
  SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE,
  SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES,
  SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  SET_CART_BOWLERS_FOR_CART_ROSTER_ID,
  SET_CART_ROSTER,
  SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART,
  SET_CART_ROSTERS_COMPLETE,
  SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES,
  SET_CART_ROSTER_ON_EDITING_ENTRY,
  SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  SET_CURRENT_ROSTER_CART_ID,
  SET_CURRENT_ROSTER_CART_COMPLETE,
  SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE,
  SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE,
  SET_IS_PROFESSIONAL_FOR_REG_ROSTER,
  SET_MEMBER_AVG_FIELD,
  SET_MEMBER_SEARCH_FIELD,
  SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT,
  SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES,
  SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES,
  SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES,
  SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  SET_VIRTUAL_ENTRY_ROSTER_COMPLETE,
  STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP,
  UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY,
  UPDATE_ROSTER_INFO,
  UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART,
  VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE,
  VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE,
  SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE,
  CLEAR_SHARED,
  CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES
} from './constants';

import {
  CLEAR_SCHEDULER_ITEMS
} from 'shared/constants';

export const displayEntries = data => ({
  type: DISPLAY_PURCHASED_ENTRIES,
  payload: data
});
  
export const displayVirtualEntries = virtualEntries => ({
  type: DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE,
  payload: virtualEntries
});

export const displayTeamOwnedVirtualEntries = (data, entryId, bowlerCount) => ({
  type: DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES,
  payload: {
    data,
    entryId,
    bowlerCount
  }
});

export const displayClearCartConfirmation = showModal => ({
  type: DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN,
  payload: showModal
});

export const clearSchedulerItems = () => ({
  type: CLEAR_SCHEDULER_ITEMS
});

export const calculateBalanceDue = () => ({
  type: CALCULATE_BALANCE_DUE_FOR_REG_MANAGE
});

export const displayCountriesInDropDown = countries => ({
  type: DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM,
  payload: countries
});

export const displayStatesInDropDown = states => ({
  type: DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM,
  payload: states
});

export const cancelEntryDetails = () => ({
  type: CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE
});

export const cancelEntryPaymentLogHistory = () => ({
  type: CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE
});

export const cancelPurchasedEntryForm = () => ({
  type: CANCEL_PURCHASED_ENTRY_FORM
});

export const closeVirtualEntryEditing = () => ({
  type: CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE
});

export const cancelVirtualEventPaymentLogHistory = () => ({
  type: CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE
});

export const displayEntryDetails = entryId => ({
  type: DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE,
  payload: entryId
});

export const displayPurchasedEntryForm = entryId => ({
  type: DISPLAY_PURCHASED_ENTRY_FORM,
  payload: entryId
});

export const displayRosterPositions = rosterPositions => ({
  type: DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES,
  payload: rosterPositions
});

export const displayVirtualEntryBowlerList = virtualEventId => ({
  type: DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  payload: virtualEventId
});

export const handleRemoveUnassignedChildVirtualEntries = virtualEventName => ({
  type: REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  payload: {virtualEventName}
});

export const handleRemoveUnassignedParentVirtualEntries = virtualEventName => ({
  type: REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT,
  payload: {virtualEventName}
});

export const setAvailableBowlersInState = bowlers => ({
  type: SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE,
  payload: bowlers
});

export const setAvailableBowlersInStateForVirtualEntries = bowlers => ({
  type: SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES,
  payload: bowlers
});

export const setEntryDetailsInState = entryDetails => ({
  type: SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE,
  payload: entryDetails
});

export const setEntryStateDisabled = (entryId, disabled) => ({
  type: SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE,
  payload: {entryId, disabled}
});

export const setRemoveVirtualEntryConfirmationVisibility = (visible, virtualEventName, childOrParent, quantity) => ({
  type: SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT,
  payload: {visible, virtualEventName, childOrParent, quantity}
});

export const setRosterConfirmationVisibility = (visible, nextAction, args) => ({
  type: SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES,
  payload: {visible, nextAction, args}
});

export const setVirtualEntryBowlerList = bowlerList => ({
  type: SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  payload: bowlerList
});

export const setCartVirtualEntryBowlerList = bowlerList => ({
  type: SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE,
  payload: bowlerList
});

export const setVirtualEventSelectedEntry = virtualEventId => ({
  type: SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES,
  payload: virtualEventId
});

export const virtualEntrySubmittingFinished = () => ({
  type: VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE
});

export const virtualEntrySubmittingStarts = () => ({
  type: VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE
});

export const setBowlerForVirtualEntry = (virtualEntryId, bowlerId) => ({
  type: SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  payload: {virtualEntryId, bowlerId}
});

export const setBowlerForCartVirtualEntry = (virtualEntryId, bowlerId) => ({
  type: SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE,
  payload: {virtualEntryId, bowlerId}
});

export const setBowlerForCartVirtualEntryAlreadyAssigned = payload => ({
  type: SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE,
  payload: payload
});

export const removeVirtualEntryBowlerFromCart = (bowlerId) => ({
  type: REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART,
  payload: {bowlerId}
});

export const updateVirtualAvailableEntryFromCart = (cartRosterId, virtualEventId, virtualEntryQuantity) => ({
  type: UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART,
  payload: {cartRosterId, virtualEventId, virtualEntryQuantity}
});

export const moveRosterDown = index => ({
  type: MOVE_POSITION_DOWN_FOR_REG_ROSTERS,
  payload: index
});

export const moveRosterUp = index => ({
  type: MOVE_POSITION_UP_FOR_REG_ROSTER,
  payload: index
});

export const reinsertManagedRosterIdsToCart = tempCartEntries => ({
  type: REINSERT_MANAGED_ROSTER_IDS_INTO_CART,
  payload: tempCartEntries
});

export const setIsProfessional = (position, value) => ({
  type: SET_IS_PROFESSIONAL_FOR_REG_ROSTER,
  payload: {
    position,
    value
  }
});

export const updateRosterInfo = data => ({
  type: UPDATE_ROSTER_INFO,
  payload: data
});

export const searchingStarts = data => ({
  type: SEARCHING_MEMBER_STARTS,
  payload: data
});

export const searchingFinished = () => ({
  type: SEARCHING_MEMBER_FINISHED
});

export const setMemberSearchField = roster => ({
  type: SET_MEMBER_SEARCH_FIELD,
  payload: roster
});

export const setMemberAvgField = (position, value) => ({
  type: SET_MEMBER_AVG_FIELD,
  payload: {
    position,
    value
  }
});

export const clearRosterPosition = index => ({
  type: CLEAR_POSITION_FOR_REG_ROSTERS,
  payload: index
});

export const assignChildTeamOwnedVirtualEntry = (virtualEventName, parentTeamEntryId, rosterPosition, value) => ({
  type: ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  payload: {
    virtualEventName,
    parentTeamEntryId,
    rosterPosition,
    value
  }
});

export const assignTeamOwnedVirtualEntry = (virtualEventName, teamEntryId, value) => ({
  type: ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY,
  payload: {
    virtualEventName,
    teamEntryId,
    value
  }
});

export const storeTeamOwnedVirtualEntryMap = (virtualEventName, teamEntryId, value) => ({
  type: STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP,
  payload: {
    virtualEventName,
    teamEntryId,
    value
  }
});

export const displayPaymentLogHistory = entryId => ({
  type: DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  payload: entryId
});

export const displayVirtualEventPaymentLog = virtualEventId => ({
  type: DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE,
  payload: virtualEventId
});

export const setEntrySelectedEntry = entryId => ({
  type: SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES,
  payload: entryId
});

export const createCartRosterPositions = (eventNumberOfBowlers, averageBased) => ({
  type: CREATE_CART_ROSTER_POSITIONS,
  payload: { eventNumberOfBowlers, averageBased }
});

export const convertEntriesFromCart = (squads, events) => ({
  type: CONVERT_ENTRIES_FROM_CART,
  payload: { squads, events }
});

export const convertVirtualEntriesFromCart = squads => ({
  type: CONVERT_VIRTUAL_ENTRIES_FROM_CART,
  payload: squads
});

export const setCurrentCartRosterId = (oldId, newId) => ({
  type: SET_CURRENT_ROSTER_CART_ID,
  payload: { oldId, newId }
});

export const setCurrentCartRosterComplete = name => ({
  type: SET_CURRENT_ROSTER_CART_COMPLETE,
  payload: name
});

export const setCartRostersComplete = (cartRosterId, cartRoster) => ({
  type: SET_CART_ROSTERS_COMPLETE,
  payload: {cartRosterId, cartRoster}
});

export const setVirtualEntryRosterComplete = (cartRosterId, cartRoster) => ({
  type: SET_VIRTUAL_ENTRY_ROSTER_COMPLETE,
  payload: {cartRosterId, cartRoster}
});

export const setCartRoster = cartRoster => ({
  type: SET_CART_ROSTER,
  payload: cartRoster
});

export const setCartBowlersForCartRosterId = (cartBowlers, cartRosterId) => ({
  type: SET_CART_BOWLERS_FOR_CART_ROSTER_ID,
  payload: { cartBowlers, cartRosterId }
});

export const clearCartItems = () => ({
  type: CLEAR_CART_ITEMS
});

export const removeCartEntry = cartRosterId => ({
  type: REMOVE_CART_ENTRY,
  payload: cartRosterId
});

export const updateCartEntryForParentTeamOwnedVirtualEntry = (virtualEventName, teamEntryId, value) => ({
  type: UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY,
  payload: {
    virtualEventName,
    teamEntryId,
    value
  }
});

export const updateCartEntryForChildTeamOwnedVirtualEntry = (virtualEventName, teamEntryId, value, rosterPosition) => ({
  type: UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY,
  payload: {
    virtualEventName,
    teamEntryId,
    value,
    rosterPosition
  }
});

export const resetTeamOwnedVirtualEntryEventAssignment = () => ({
  type: RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT
});

export const setCartRosterOnEditingEntry = (cartRosterId) => ({
  type: SET_CART_ROSTER_ON_EDITING_ENTRY,
  payload: {
    cartRosterId: cartRosterId
  }
});

export const setCartRosterIdForVirtualEventInCart = (virtualEvents, virtualEventId, cartRosterId) => ({
  type: SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART,
  payload: {
    virtualEvents,
    virtualEventId,
    cartRosterId
  }
});

export const setCartRosterOnCartVirtualEntries = (assignedVirtualEntries, cartRosterId) => ({
  type: SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES,
  payload: {
    assignedVirtualEntries,
    cartRosterId
  }
});

export const clearCartBowlers = () => ({
  type: CLEAR_CART_BOWLERS
});

export const clearShared = () => ({
  type: CLEAR_SHARED
});

export const clearPurchasedTeamOwnedVirtualEntries = () => ({
  type: CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES
});



// WEBPACK FOOTER //
// ./src/features/registration/shared/actionTypes.js